import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box my={3}>
        <Skeleton variant="text" width="50%" />
      </Box>
      <Box width="100%" mb={3}>
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="80%" />
      </Box>
    </Box>
  );
};

export default Loading;
